import { ControlProperty } from '../../../../../common/models';
import { DraggableFilterType } from '../../../../constants';

export enum PlantFormGroupName {
  Details = 'details',
  ExternalIds = 'extIds',
}

export enum PlantManagementFilterName {
  PlantShortName = 'plantCode',
  PlantFullName = 'plantName',
  SapPlantId = 'sapPlantId',
  SapSystem = 'sapInboundSystem',
}

export const PLANT_MANAGEMENT_FILTER_TYPE_BY_NAME: Map<PlantManagementFilterName, DraggableFilterType> = new Map([
  [PlantManagementFilterName.PlantShortName, DraggableFilterType.Input],
  [PlantManagementFilterName.PlantFullName, DraggableFilterType.Input],
  [PlantManagementFilterName.SapPlantId, DraggableFilterType.Input],
  [PlantManagementFilterName.SapSystem, DraggableFilterType.Input],
]);

export class PlantListFiltersModelBase {
  [PlantManagementFilterName.PlantShortName]: string = null;
  [PlantManagementFilterName.PlantFullName]: string = null;
  [PlantManagementFilterName.SapPlantId]: string = null;
  [PlantManagementFilterName.SapSystem]: string = null;

  constructor(params?: PlantListFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PlantListFilterForm {
  constructor(
    model: PlantListFiltersModelBase,

    public plantCode: ControlProperty<string> = [model.plantCode, []],
    public plantName: ControlProperty<string> = [model.plantName, []],
    public sapPlantId: ControlProperty<string> = [model.sapPlantId, []],
    public sapInboundSystem: ControlProperty<string> = [model.sapInboundSystem, []],
  ) {}
}
